import React from 'react';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';
import { DelayedSmartPageSignupStepWithI18n } from './delayed-smart-page-signup-step';

export const SmartPageSignupStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_SIGNUP,
  render: () => <DelayedSmartPageSignupStepWithI18n />,
};
